/**
 * Alpine component behind the small "copy to clipboard" buttons rendered next
 * to email addresses (see `CopyHelper#copy_button`). `copy` takes the value as
 * an argument so Alpine-rendered lists can pass a client-side expression such
 * as `attendee.email` instead of a server-rendered literal.
 */
const RESET_DELAY_MS = 2000;

function fallbackCopy(text) {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
}

export function copyButtonData({ setTimeoutFn = setTimeout } = {}) {
  return {
    copied: false,

    copy(text) {
      const value = (text || "").toString();
      if (!value) return;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value).catch(() => fallbackCopy(value));
      } else {
        fallbackCopy(value);
      }

      this.copied = true;
      setTimeoutFn(() => {
        this.copied = false;
      }, RESET_DELAY_MS);
    }
  };
}

export default function registerCopyButton(Alpine) {
  Alpine.data("copyButton", () => copyButtonData());
}
